import classnames from 'classnames';

import { VODCSSModules } from 'shared/utils/wix-connect';

import styles from './title.styl';


@VODCSSModules(styles)
export default class Title extends React.Component {

  static propTypes = {
    title: React.PropTypes.string,
    isInFullScreen: React.PropTypes.bool,
  };

  render() {
    const { isInFullScreen, title } = this.props;

    const styleNames = classnames('wrapper', {
      'at-full-screen': isInFullScreen,
    });

    return (
      <div styleName={styleNames}>
        <span styleName="title"
              className="qa-overlay-title"
              data-hook="playerTitle">
          {title}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/title/title.js